import styled, { css } from 'styled-components';

import { mediaQuery, Text } from '@catalyze/ui';

export const TimelineWrapper = styled.section`
    --timeline-line-color: #cfd7da;
    --timeline-circle-size: 0.625rem;

    grid-area: timeline;
    display: flex;
    flex-flow: column;
    row-gap: 1rem;
    justify-content: flex-start;
    justify-self: flex-start;
    width: 21.5rem;
    height: max-content;
    border: ${({ theme }) => `1px solid ${theme.colors.darkShadow}`};
    border-radius: 0.5rem;
    padding: 1rem 1.5rem;
    max-height: 100vh;
    overflow-y: overlay;
    ${mediaQuery(
        3,
        css`
            justify-self: flex-end;
        `
    )}
`;

export const TimelineTitle = styled(Text)`
    font-weight: 700;
    font-size: ${({ theme }) => theme.fontSizes[6]};
    margin-bottom: 0.5rem;
`;
